//component entry file
import Suitability from "./components/main/Suitability.vue";
import Methodology from "./components/main/Methodology";

export default {Suitability,Methodology};